import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"
import { APIResponse } from "shared/models/api-response";
import { BehaviorSubject, tap } from "rxjs";
import { DashboardCounters } from "shared/models/dashboard-counters";

@Injectable({
    providedIn: 'root'
})
export class DashboardApiService {

    constructor(private http: HttpClient) { }

    private _counters$ = new BehaviorSubject<DashboardCounters>(new DashboardCounters());
    public counters$ = this._counters$.asObservable();

    
    public getCounters() {
        return this.http.get(API_HOST + `dashboard/counters`).pipe(
            tap((response: APIResponse) => {
                if(response.success != true) return
                this._counters$.next(new DashboardCounters(response.data))
            })
        )
    }
    
    public getLastMarkouts() {
        return this.http.get(API_HOST + `dashboard/recent-markouts`)
    }
    
}